import { useCallback as p } from "react";
import { isEmpty as c } from "@biron-data/react-components";
import { SemanticType as l } from "../MetaModel.js";
const s = (r) => p(
  (t) => r.filter(({ asSimple: e }) => !e).map((e) => ({
    type: l.NUMBER,
    label: e.alias,
    value: e.code,
    selected: !c(t.find((o) => o.reference.code === e.code))
  })).sort((e, o) => e.label.localeCompare(o.label)),
  [r]
);
export {
  s as useDimensionOptions
};
//# sourceMappingURL=useDimensionOptions.js.map
